import { createFileRoute } from '@tanstack/react-router';

import { BCPAllPlansLiveWorkspace } from '@/features/bcp/components/BCPAllPlansLiveWorkspace';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/bcp')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.businessContinuityWorkspace'),
  }),
  component: BusinessContinuityBcpPage,
});

function BusinessContinuityBcpPage() {
  return <BCPAllPlansLiveWorkspace />;
}
